import { Flip, ToastContainer, toast } from "react-toastify";
import { useState } from "react";

const Header = (props) => {
  const [isConnecting, setIsConnecting] = useState(false);

  const toggleSideBar = () => {
    if (props.sideBarToggle) {
      props.sideBarToggle();
    }
  };

  const handleConnect = async () => {
    if (isConnecting) return;
    
    setIsConnecting(true);
    try {
      await props.onConnectWallet();
    } catch (error) {
      console.error("Connection failed:", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const handleDisconnect = async () => {
    if (props.onDisconnect) {
      await props.onDisconnect();
    }
  };

  // Format address for display
  const formatAddress = (address) => {
    if (!address) return "";
    return address.slice(0, 5) + "..." + address.slice(address.length - 4, address.length);
  };

  return (
    <div
      style={{ backgroundColor: "rgba(30, 166, 239, 0)" }}
      className="fixed top-0 left-1/2 -translate-x-1/2 flex justify-center w-full px-5 sm:px-10 lg:p-0 lg:max-h-screen z-999999"
    >
      <div
        style={{
          background: "rgba(98, 10, 240, 0.25)",
          boxShadow: "0 8px 32px 0 rgba(58, 67, 159, 0.37)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          borderRadius: "10px",
          border: "1px solid rgba(255, 255, 255, 0.18)",
        }}
        className="flex justify-between items-center rounded-mini max-w-desktop-preview-bar w-full px-3 sm:px-5 py-2 shadow-preview-bar lg:pl-10 sm:pl-5 lg:py-2.5 lg:rounded-none lg:rounded-b-mini lg:pr-0"
      >
        <div className="flex w-full overflow-hidden items-center justify-between space-x-2.5 lg:items-start">
          <div className="w-full flex justify-start items-center space-x-5 lg:flex-col lg:h-full lg:items-start lg:space-x-0 lg:space-y-7.5">
            <div className="flex items-center false lg:w-full lg:pr-10 sm:pr-5">
              <a href="/" className="header-link" style={{ marginRight: "15px sm:mr-95px" }}>
                <img
                  style={{ width: "50px", height: "50px", sm: { width: "50px", height: "50px" } }}
                  src="/logo/logo.gif"
                  className="light"
                  alt="Logo"
                />
                <img
                  style={{ width: "50px", height: "50px", sm: { width: "50px", height: "50px" } }}
                  src="/logo/logo.gif"
                  className="dark"
                  alt="Logo"
                />
              </a>
            </div>
          </div>
          
          {/* Wallet Connection Button - Always visible on mobile */}
          {!props.signer && !props.userAddress ? (
            <button
              className="flex justify-center items-center text-center text-sm sm:text-base font-bold text-white rounded-mini outline-none px-3 sm:px-5 py-2 sm:py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 whitespace-nowrap shadow-lg"
              onClick={handleConnect}
              disabled={isConnecting || props.isConnecting}
              id="connectWallet"
            >
              {isConnecting || props.isConnecting ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span className="hidden sm:inline">Connecting...</span>
                  <span className="sm:hidden">...</span>
                </span>
              ) : (
                <>
                  <span className="hidden sm:inline">Connect Wallet</span>
                  <span className="sm:hidden">Connect</span>
                </>
              )}
            </button>
          ) : (
            <div className="flex items-center space-x-2 sm:space-x-3">
              {/* Wallet Address Display */}
              <div className="flex justify-center items-center text-center text-xs sm:text-base font-bold text-white rounded-full outline-none px-2 sm:px-4 py-1.5 sm:py-2 bg-white bg-opacity-20 backdrop-blur-sm">
                <div className="flex items-center space-x-1 sm:space-x-2">
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="truncate max-w-[80px] sm:max-w-none" style={{color: "black"}}>
                    {props.userAddress ? formatAddress(props.userAddress) : ""}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
        
        <div className="flex lg:justify-end lg:ml-auto lg:pr-10 sm:pr-5">
          {/* Disconnect Button - Only show when wallet is connected */}
          {(props.signer || props.userAddress) && (
            <button
              onClick={handleDisconnect}
              className="flex justify-center items-center text-center text-base font-bold text-white rounded-full outline-none bg-red-500 hover:bg-red-600 w-8 h-8 sm:w-10 sm:h-10 !p-0 ml-2 sm:ml-5 transition-colors shadow-lg"
              title="Disconnect Wallet"
            >
              <svg
                className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M18 6 6 18M6 6l12 12"></path>
              </svg>
            </button>
          )}
          
          {/* Mobile Menu Button */}
          {!props.isHome && (
            <div className="">
              <button
                onClick={toggleSideBar}
                className="mobile-menu-button flex justify-center items-center text-center text-base font-bold text-white rounded-full outline-none bg-white bg-opacity-20 hover:bg-opacity-30 flex-col w-8 h-8 sm:w-10 sm:h-10 !p-0 ml-2 sm:ml-5 lg:hidden transition-all"
              >
                <span className="w-3 sm:w-4 border-t border-white mb-1"></span>
                <span className="w-3 sm:w-4 border-t border-white"></span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;